export const OLD_SLA_FORMAT = 'OLD_SLA_FORMAT' as const;
export const NEW_SLA_FORMAT = 'NEW_SLA_FORMAT' as const;
